export default "__VITE_ASSET__w1UBi1uJ__"